export function iframeCode(link: string) {
  return `<iframe src="${link}" width="100%" height="100%" frameborder="0" scrolling="no"></iframe>`
}
export const supportCode = `
<div id="wnhub_iframe_popup"
  style="position: fixed; z-index: 100000; top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 100%; display: none;">
  <style>
    @keyframes spin {
      100% {
        transform: rotate(360deg)
      }
    }
  </style>
  <div id="wnhub_iframe_loader"
    style="display: flex; height: 100vh; justify-content: center; align-items: center; background-color: rgb(140 153 171 / 0.75);">
    <svg style="animation: spin 1s linear infinite; height: 2rem; width: 2rem;" viewBox="0 0 24 24" fill="none">
      <circle style="opacity: 0.25;" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
      <path style="opacity: 0.75;" fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
    </svg>
  </div>
</div>

<script>
  (function () {
    var CART_ELEMENT_ID = 'wnhub_cart'
    var cartElement, cartCountElement
  
    function onResize() {
      console.log('post update-block-height message');
      window.parent.postMessage({ event: 'update-block-height', height: document.body.scrollHeight }, '*');
    }
    window.addEventListener('load', onResize);
    window.addEventListener('resize', onResize);
      
    window.addEventListener('message', function (event) {
      if (!['https://wnhub.io', 'http://localhost:3000'].includes(event.origin)) {
        return
      }
  
      event.data.message_type && console.log('got block message', event.data)
  
      if (event.data.message_type === 'close_popup') {
        window.wnhub_iframe_popup.removeChild(window.wnhub_iframe_popup.querySelector('iframe'))
        window.wnhub_iframe_popup.style.display = 'none'
      }
  
      if (event.data.message_type === 'open_popup') {
        var iframe = document.createElement('iframe')
        iframe.src = event.data.url
        iframe.width = '100%'
        iframe.id = 'wnhub_iframe_content'
        iframe.height = '100%'
        iframe.frameBorder = '0'
        iframe.scrolling = 'no'
        iframe.style = 'border: 0; display: block; position: absolute; top:0; left: -200vw'
        iframe.onload = function () {
          iframe.style.left = '0'
        }
        window.wnhub_iframe_popup.appendChild(iframe)
        window.wnhub_iframe_popup.style.display = 'block'
      }
  
      if (event.data.message_type === 'resize') {
        var iframes = document.querySelectorAll(\`iframe[src="\${event.data.url}"]\`)
  
        if (iframes.length) {
          iframes[0].style.height = event.data.frameHeight + 'px'
        }
      }
      
      if (event.data.message_type === 'init_cart') {
        cartElement = document.getElementById(CART_ELEMENT_ID)
        
        if (!cartElement) {
          cartElement = document.createElement('a')
          document.body.appendChild(cartElement)
  
          cartElement.id = CART_ELEMENT_ID
          cartElement.target = '_blank'
          cartElement.style.cssText = 'top: 6rem; display: none; align-items: center; font-weight: 600; font-family: ui-sans-serif, system-ui, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; position: fixed; z-index: 9000; right: 1rem; right: max(calc(((100vw - 1160px) / 4) - 36px), 1rem); border-radius: 0.75rem; justify-content: center; background-color: #ffffff; padding: 1rem; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.1); transition-duration: 150ms;'
          cartElement.innerHTML = \`
           <div data-icon="outline_ticket_thin" style="display: flex; align-items: center; justify-content: center; height: 2.5rem; width: 2.5rem; color: #2b81f2;" >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                 style="height: 100%;width: 100%;">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                    d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"></path>
            </svg>
          </div>
          <div id="wnhub_cart_count" style="position: absolute; top: -0.5rem; right: -0.5rem; display: flex; align-items: center; justify-content: center; background-color: #ef4444; border-radius: 9999px; height: 1.25rem; width: 1.25rem; color: #ffffff; font-size: 0.75rem;"></div>
          \`
        }
        
        cartCountElement = document.getElementById('wnhub_cart_count')
        
        setCartParams(event.data.count, event.data.link)
        
        event.source.postMessage({
          message_type: 'cart_initialized'
        }, event.origin)
      }
      
      if (event.data.message_type === 'update_cart') {
        if (!cartElement || !cartCountElement) {
          return
        }
  
        setCartParams(event.data.count, event.data.link)
        
        if (event.data.count) {
          cartElement.style.transform = 'scale(1.25)'
          setTimeout(() => {
            cartElement.style.transform = ''
          }, 150)
        }
      }
    })

    function setCartParams(count, link) {
      cartElement.href = link
      cartElement.style.display = count ? 'block' : 'none'
      cartCountElement.textContent = count
    }
  })()
</script>`
